export const AIS_PHONE = '+39 0734 996170';
export const AIS_EMAIL = 'info@hsign.it';
export const AIS_ADDRESS = 'Via del Lavoro n. 6/8 - 63846 Monte Giberto (FM)';
export const AIS_INSTAGRAM_URL = '';
export const AIS_INSTAGRAM_NAME = '';
export const AIS_TWITTER_URL = '';
export const AIS_TWITTER_NAME = '';
